import { UpdateEquipment } from '../../equipment/editEquipment/updateEquipment';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useHasPermission } from '../../../hooks/useHasPermission';
import { Box, Typography, Menu, MenuItem } from '@mui/material';
import useResponsive from '../../../hooks/useResponsive';
import { DeleteRecord } from '../../deleteRecord';
import { useTranslation } from 'react-i18next';
import { useListBackNavigation } from '../../../hooks/listNavigation';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import Iconify from '../../Iconify';
import axios from 'axios';
import '../../../css/roles/roleDetailsHeader.css';

const EquipmentDetailsHeader = () => {

    const { t } = useTranslation();
    const { goBack, goToList } = useListBackNavigation('/dashboard/equipements');
    const isDesktop = useResponsive('up', 'lg');

    const equipmentDetailsData = useSelector((state) => state.EquipmentDetailsData);

    const hasEquipmentUpdatePermission = useHasPermission('equipment_update');
    const hasEquipmentDeletePermission = useHasPermission('equipment_delete');

    const [updateEquipmentOpen, setUpdateEquipmentOpen] = useState(false);
    const [deleteEquipmentOpen, setDeleteEquipmentOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [errMsg, setErrMsg] = useState(null);

    const openActionMenu = Boolean(anchorEl);

    const handleDeleteEquipment = async () => {
        try {
            const response = await axios.delete(`equipment/${equipmentDetailsData.id}`);
            if (response.status === 200 || response.status === 201) {
                setDeleteEquipmentOpen(false);
                goToList();
                setErrMsg('');
            }
        } catch (error) {
            setErrMsg(error.response?.data?.message || error.message || t('Une erreur est survenue lors de la suppression de l\'équipement.'));
            console.error('Error deleting equipment:', error);
            CustomErrorLogger(error, "Delete equipment in EquipmentDetailsHeader");
        }
    }

    const handleOpenActionMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseActionMenu = () => {
        setAnchorEl(null);
    };

    const handleGoBack = goBack;

    return (
        <Box className="roleDetailsHeader_mainBox">
            <Box className="roleDetailsHeader_firstPart">
                <Iconify className='roleDetailsHeader_back_icon' icon={"material-symbols:arrow-back"} onClick={handleGoBack} />
                <Typography className="roleDetailsHeader_title">{equipmentDetailsData?.name}</Typography>
                {hasEquipmentUpdatePermission && <Iconify className='roleDetailsHeader_edit_icon' icon={"ic:outline-edit"} onClick={() => setUpdateEquipmentOpen(true)} />}
                {equipmentDetailsData?.description}
            </Box>
            <Box className="roleDetailsHeader_secondPart">
                {isDesktop && hasEquipmentDeletePermission &&
                    <Box className="roleDetailsHeader_action_box" onClick={() => setDeleteEquipmentOpen(true)}>
                        <Iconify className='roleDetailsHeader_delete_icon' icon={"ic:outline-delete"} />
                        <Typography className="roleDetailsHeader_delete_title">{t('Supprimer')}</Typography>
                    </Box>
                }
                {!isDesktop && <Iconify
                    className='roleDetailsHeader_dots_icon'
                    icon={"vaadin:ellipsis-dots-v"}
                    id="userPageActionMenuIcom"
                    aria-controls={openActionMenu ? 'long-menu' : undefined}
                    aria-expanded={openActionMenu ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleOpenActionMenu}
                />}
                <Menu
                    id="usersePageActionMenu"
                    MenuListProps="usersPageActionMenuIcom"
                    open={openActionMenu}
                    anchorEl={anchorEl}
                    onClose={handleCloseActionMenu}
                    onClick={handleCloseActionMenu}
                    slotProps={{ paper: { style: { width: '30ch', backgroundColor: '#fffff' } } }}
                >
                    {!isDesktop && hasEquipmentDeletePermission &&
                        <MenuItem className='roleDetailsHeader_menuItem' onClick={() => setDeleteEquipmentOpen(true)}>
                            <Iconify className='roleDetailsHeader_delete_icon' icon={"ic:outline-delete"} />
                            <Typography className="roleDetailsHeader_delete_title">{t('Supprimer')}</Typography>
                        </MenuItem>
                    }
                </Menu>
            </Box>

            {updateEquipmentOpen &&
                <UpdateEquipment
                    updateEquipmentOpen={updateEquipmentOpen}
                    setUpdateEquipmentOpen={setUpdateEquipmentOpen}
                />
            }

            {deleteEquipmentOpen &&
                <DeleteRecord
                    errMsg={errMsg}
                    setErrMsg={setErrMsg}
                    openDelete={deleteEquipmentOpen}
                    setOpenDelete={setDeleteEquipmentOpen}
                    handleDelete={handleDeleteEquipment}
                    title="Êtes-vous sûr de vouloir supprimer cet équipement ?"
                />
            }
        </Box>
    );
}

export default EquipmentDetailsHeader;